import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { fetchSecret } from "../config/secret-retriever.config";

const firebaseConfig = {
   apiKey: fetchSecret("FIREBASE_API_KEY"),
   authDomain: fetchSecret("FIREBASE_AUTH_DOMAIN"),
   projectId: fetchSecret("FIREBASE_PROJECT_ID"),
   storageBucket: fetchSecret("FIREBASE_STORAGE_BUCKET"),
   messagingSenderId: fetchSecret("FIREBASE_MESSAGING_SENDER_ID"),
   appId: fetchSecret("FIREBASE_APP_ID"),
};
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);